export default __webpack_public_path__ + "search-examples-list-based-search-thumbnail-480-bbdc4021b0726d1792392858585dc062.webp";